package haxe.ui.containers;

/**
 A `Box` component where only one child is visible at a time
**/
@:dox(icon = "/icons/ui-layered-pane.png")
class Stack extends Box {
    public function new() {
        super();
    }
}